import React from 'react';
import clsx from 'clsx';
import { Avatar as AvatarAntd } from 'antd';
import type { AvatarProps } from 'antd/lib/avatar';
export type { AvatarProps } from 'antd/lib/avatar';
import styles from './Avatar.module.scss';
const Avatar: React.FC<AvatarProps> = ({ children, className, ...props }) => {
  return (
    <AvatarAntd className={clsx(styles.override, className)} {...props}>
      {children}
    </AvatarAntd>
  );
};

export default Avatar;
